import { render, staticRenderFns } from "./DropdownMenuItem.vue?vue&type=template&id=0484c8d9&scoped=true"
import script from "./DropdownMenuItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./DropdownMenuItem.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0484c8d9",
  null
  
)

export default component.exports